<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "MyCredentialLayout"
    }
</script>

<style scoped>

</style>
